export default {
    AMToolNotAvailable: {
        title: 'Ooops!<br />We are sorry!',
        text: 'The AM 4.0 Tool is not available until the  second season.'
    },
    notEnoughCredits: {
        title: 'Ooops!<br />You don’t have enough money!',
        text: 'We are sorry, you can’t select so many items. You don’t have enough money.'
    },
    drivingAggressiveExceeded: {
        title: 'Ooops!<br />Your driving is super aggressive!',
        text: 'You can’t select aggressive driving style, more than {{threshold}} times.'
    },
    notEnoughCreditsPitstops: {
        title: 'Ooops!<br />You don’t have enough money!',
        text: 'We are sorry, due to an incorrect plannification, if you need more tires the FIA will give you their selection with less performance and more expensive (in debt).'
    },
    maxUnitsExceed: {
        title: 'Ooops!<br />You can’t select more units!',
        text: 'We are sorry, you can’t select so many items.'
    },
    timeout: {
        title: 'Ooops!<br />Your time is out!',
        text: 'The not selected items, would be selected the worst ones by default.'
    },
    selectionConfirmation: {
        title: 'Are you sure you want to end the selection?',
        text: 'You have time left. If you quit now without choosing your preference a standard selection will be made for you.',
        doneBtn: 'END SELECTION',
        cancelBtn: 'CONTINUE SELECTING'
    },
    tooAggressiveDriving: {
        title: 'Ooops!<br />Your driving is super aggressive!',
        text: 'You can’t select aggressive driving style, more than 4 times.'
    },
    itemJustInformative: {
        title: 'Ooops!',
        text: 'This item it\'s just informative. You can\'t make any decision.'
    },
    endGameConfirmation: {
        title: 'Are you sure you want to exit the game?',
        text: 'You will exit this current game and go to home.',
        doneBtn: 'EXIT & GO TO HOME',
        cancelBtn: 'CONTINUE SEEING THE RESULTS'
    },
    mcNewGameBotsConfirmation: {
        title: 'Are you sure you want to use these values?',
        text: 'Please, choose carefully the values for the bots generation. It could take several minutes to generate them.',
        doneBtn: 'YES, I\'M SURE',
        cancelBtn: 'NO, LET ME CHECK AGAIN'
    },
}



// WEBPACK FOOTER //
// src/lang/locales/en/modals.js